import { GetterTree } from 'vuex';
import { IAPIStoreState, IVuexRootStoreState } from '@/types';

export const apiGetters: GetterTree<IAPIStoreState, IVuexRootStoreState> = {};
